import { createI18n } from 'vue-i18n';
import { nextTick } from 'vue';

export const SUPPORT_LOCALES = [
  {
    key: 'en',
    message: 'en',
    load: () => import('./en.json'),
    elMessageFunc: () => import('element-plus/dist/locale/en.mjs'),
  },
  {
    key: 'zh',
    message: 'zh_CN',
    load: () => import('./zh_CN.json'),
    elMessageFunc: () => import('element-plus/dist/locale/zh-cn.mjs'),
  },
  {
    key: 'zh-TW',
    message: 'zh_TW',
    load: () => import('./zh_TW.json'),
    elMessageFunc: () => import('element-plus/dist/locale/zh-tw.mjs'),
  },
  {
    key: 'ja',
    message: 'ja',
    load: () => import('./ja.json'),
    elMessageFunc: () => import('element-plus/dist/locale/ja.mjs'),
  },
  {
    key: 'ko',
    message: 'ko',
    load: () => import('./ko.json'),
    elMessageFunc: () => import('element-plus/dist/locale/ko.mjs'),
  },
  {
    key: 'fr',
    message: 'fr',
    load: () => import('./fr.json'),
    elMessageFunc: () => import('element-plus/dist/locale/fr.mjs'),
  },
  {
    key: 'de',
    message: 'de',
    load: () => import('./de.json'),
    elMessageFunc: () => import('element-plus/dist/locale/de.mjs'),
  },
  {
    key: 'es',
    message: 'es',
    load: () => import('./es.json'),
    elMessageFunc: () => import('element-plus/dist/locale/es.mjs'),
  },
  {
    key: 'pt',
    message: 'pt',
    load: () => import('./pt.json'),
    elMessageFunc: () => import('element-plus/dist/locale/pt.mjs'),
  },
  {
    key: 'it',
    message: 'it',
    load: () => import('./it.json'),
    elMessageFunc: () => import('element-plus/dist/locale/it.mjs'),
  },
  {
    key: 'ru',
    message: 'ru',
    load: () => import('./ru.json'),
    elMessageFunc: () => import('element-plus/dist/locale/ru.mjs'),
  },
  {
    key: 'vi',
    message: 'vi',
    load: () => import('./vi.json'),
    elMessageFunc: () => import('element-plus/dist/locale/vi.mjs'),
  },
];

export const getLocale = async (local) => {
  let loc = SUPPORT_LOCALES.find((item) => item.key === local);
  if (!loc) {
    loc = SUPPORT_LOCALES.find((item) => item.key === 'en');
  }
  if (!loc.elMessage) {
    const elmsg = await loc.elMessageFunc();
    loc.elMessage = elmsg.default;
  }
  return loc;
};

export const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {},
  legacy: false,
});

export async function setI18nLanguage(i18n, locale) {
  // console.log('setI18nLanguage', locale, i18n.availableLocales)
  if (!i18n.availableLocales.includes(locale.key)) {
    await loadLocaleMessages(i18n, locale);
  }
  // ensure fallback is also available in case of locale change
  if (!i18n.availableLocales.includes('en')) {
    await loadLocaleMessages(i18n, SUPPORT_LOCALES.find((locale) => locale.key === 'en'));
  }
  // console.log('setI18nLanguage', locale.key)
  i18n.locale = locale.key;
  document.querySelector('html')?.setAttribute('lang', locale.key);
}

export const detectLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  const lang = SUPPORT_LOCALES.find((locale) => locale.key === browserLang);
  return lang ? lang.key : 'en';
};

export async function loadLocaleMessages(i18n, locale) {
  // console.log('loadLocaleMessages', locale)
  const messages = await locale.load();
  i18n.setLocaleMessage(locale.key, messages.default);
  return await nextTick();
} 